import { Pipe, PipeTransform } from '@angular/core';
import { RoiService, VehiclePart } from '../service/roi.service';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Pipe({
  name: 'vehicleLocationPc'
})
export class VehicleLocationPcPipe implements PipeTransform {
  defaultLocation = this.i18n({
    id: 'roi_defaultLocation',
    value: "Emplacement inconnu",
    description: "Emplacement inconnu",
    meaning: "roiService"
  });

  constructor(private readonly i18n: I18n,
    private readonly _roiService: RoiService) {
  }

  transform(value: string, args?: any): string {
    if (value == undefined) {
      value = this.defaultLocation
    }
    value = value.trim();
    const vehiclePart = value.substr(0, 3);
    if (!(vehiclePart in this._roiService.parts))
      return this.defaultLocation;
    // console.log('transforming ', value, 'to', this._roiService.parts[vehiclePart].toString());
    let side: string, direction: string;

    if (value.length === 5) { // Direction only
      direction = value.substr(3, 2);
    } else if (value.length === 4) {// Side only
      side = value.substr(3, 1);
    } else { // Direction and side
      direction = value.substr(3, 2);
      side = value.substr(5, 1);
    }

    if (!side)
      side = 'C';

    let finalString = '';
    //  if (side && side in this._roiService.sides && this._roiService.parts[vehiclePart].hasSide)
    finalString = finalString.concat(
      this._roiService.parts[vehiclePart].isFeminine && side === 'D' ?
        this._roiService.sides['DF'] : this._roiService.sides[side], ' - ');

    if (vehiclePart in this._roiService.parts)
      finalString = finalString.concat(this._roiService.parts[vehiclePart]);

    if (direction && direction in this._roiService.directions && this._roiService.parts[vehiclePart].hasDirection)
      finalString = finalString.concat(' ', this._roiService.directions[direction]);



    return finalString || this.defaultLocation;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/vehicle-location-pc.pipe.ts